import { IconSvg } from './IconSvg'
import type { IconProps } from './IconSvg'

/** warning triangle. Decorative line icon; always pair with a visible text label. */
export function WarningIcon({ size, className }: IconProps) {
  return (
    <IconSvg size={size} className={className}>
      <path d="M12 3.8L2.8 19.5h18.4L12 3.8z" />
      <path d="M12 10v4" />
      <path d="M12 16.8v.01" />
    </IconSvg>
  )
}
